import { getDetailedErrorMessage } from "../../../utils/validation";
export class StationGroupsFetchFailed extends Error {
    /**
     * @param apiError - The error received from the API.
     * @param fallbackMessage - The message to use if the API error is not relevant.
     */
    constructor(apiError, fallbackMessage = "Please try again at a later time.") {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, StationGroupsFetchFailed);
        }
        this.name = "StationGroupsFetchFailed";
        this.message = `Failed to fetch station groups. ${getDetailedErrorMessage(apiError, fallbackMessage)}`;
    }
}
export class StationGroupsSaveFailed extends Error {
    /**
     * @param apiError - The error received from the API.
     * @param fallbackMessage - The message to use if the API error is not relevant.
     */
    constructor(apiError, fallbackMessage = "Failed to save station group. Please try again at a later time.") {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, StationGroupsSaveFailed);
        }
        this.name = "StationGroupsSaveFailed";
        this.message = `Failed to save station group. ${getDetailedErrorMessage(apiError, fallbackMessage)}`;
    }
}
//# sourceMappingURL=errors.js.map